/* React base class */
import { Component } from "react"

/* SEO helper */
import { applySeo } from "../../helpers"

/* Shared UI components */
import { Block } from "../../components"

/* Page ProPrivacyPolicy */
class ProPrivacyPolicy extends Component {

    componentDidMount = () => {

        /* SEO */
        applySeo({
            title: "Политика конфиденциальности Bookify Pro",
            description: "Политика конфиденциальности Bookify Pro для мастеров и владельцев салонов: обработка и защита данных.",
            path: "/partner/privacy-policy"
        })

        /* Scroll */
        window.scroll(0, 0)
    }

    render = () => {
        return (
            <Block>
                <div className="page">
                    <div className="legal">

                        <h1>Политика конфиденциальности Bookify Pro</h1>

                        <h2>1. Общие положения</h2>
                        <p>Bookify Pro (далее «Приложение») уважает конфиденциальность своих пользователей и обязуется защищать их персональные данные. Настоящая Политика конфиденциальности описывает, какие данные мы собираем, как используем, храним и передаём их.</p>

                        <h2>2. Какие данные мы собираем</h2>
                        <p>Мы можем собирать следующую информацию:</p>
                        <ul>
                            <li>Имя, фамилия, контактные данные (телефон, e-mail);</li>
                            <li>Данные о компании (название, адрес, реквизиты);</li>
                            <li>Информацию о предоставляемых услугах и записях клиентов;</li>
                            <li>Платёжные данные (без хранения конфиденциальной информации карт);</li>
                            <li>Техническую информацию (IP-адрес, данные об устройстве, cookies);</li>
                            <li>Данные, предоставляемые пользователями при использовании Приложения.</li>
                        </ul>

                        <h2>3. Как мы используем данные</h2>
                        <p>Мы используем собранные данные для:</p>
                        <ul>
                            <li>Обеспечения работы Приложения и предоставления услуг;</li>
                            <li>Улучшения качества обслуживания и персонализации функций;</li>
                            <li>Обработки платежей и взаимодействия с финансовыми партнёрами;</li>
                            <li>Отправки уведомлений и предложений, связанных с услугами;</li>
                            <li>Соблюдения требований законодательства.</li>
                        </ul>

                        <h2>4. Передача и хранение данных</h2>
                        <p>Мы не передаём персональные данные третьим лицам, за исключением случаев:</p>
                        <ul>
                            <li>Когда это требуется для предоставления услуг (например, платёжные системы);</li>
                            <li>По требованию государственных органов в рамках закона;</li>
                            <li>При необходимости защиты наших законных прав.</li>
                        </ul>
                        <p>Данные хранятся на защищённых серверах и обрабатываются в соответствии с мерами безопасности, направленными на предотвращение утечки информации.</p>

                        <h2>5. Права пользователей</h2>
                        <p>Вы имеете право:</p>
                        <ul>
                            <li>Запросить доступ к своим данным и получить их копию;</li>
                            <li>Исправить или удалить свои персональные данные;</li>
                            <li>Ограничить обработку своих данных или возразить против неё;</li>
                            <li>Отозвать согласие на обработку данных (если применимо);</li>
                            <li>Подать жалобу в регулирующие органы.</li>
                        </ul>

                        <h2>6. Защита данных</h2>
                        <p>Мы принимаем все необходимые технические и организационные меры для защиты персональных данных от утраты, несанкционированного доступа, изменения или раскрытия.</p>

                        <h2>7. Использование файлов cookie</h2>
                        <p>Приложение может использовать cookies для анализа трафика, персонализации контента и улучшения пользовательского опыта. Вы можете изменить настройки cookies в своём браузере.</p>

                        <h2>8. Изменения в политике конфиденциальности</h2>
                        <p>Мы можем периодически обновлять настоящую Политику конфиденциальности. Изменения вступают в силу с момента публикации новой версии в Приложении.</p>

                        <h2>9. Оплата, валюта и возврат средств</h2>
                    <p>Оплата подписки и услуг в Приложении производится в национальной валюте Республики Казахстан — казахстанских тенге (₸, KZT). Возврат денежных средств за неиспользованный оплаченный период осуществляется по обращению на <a href="mailto:info@bookify.kz">info@bookify.kz</a> в течение 10 (десяти) рабочих дней тем же способом и в той же валюте, которыми была произведена оплата. Подробный порядок оплаты и возврата приведён в Публичной оферте.</p>

                    <h2>10. Урегулирование споров и применимое право</h2>
                    <p>Все споры и разногласия стороны стремятся разрешить путём переговоров; претензия направляется на <a href="mailto:info@bookify.kz">info@bookify.kz</a> и рассматривается в течение 15 (пятнадцати) рабочих дней. При недостижении согласия спор подлежит разрешению в судебном порядке по месту нахождения компании. Настоящий документ и отношения сторон регулируются действующим законодательством Республики Казахстан.</p>

                    <h2>11. Контакты</h2>
                        <ul>
                            <li><strong>ТОО «SARY GROUP»</strong></li>
                            <li><strong>БИН:</strong> 240440023071</li>
                            <li><strong>Email:</strong> <a href="mailto:info@bookify.kz">info@bookify.kz</a></li>
                            <li><strong>Телефон:</strong> +7 (707) 138-51-00</li>
                            <li><strong>Адрес:</strong> Казахстан, г. Алматы, микрорайон Мамыр 1, 26, БЦ Quorum, 508 кабинет</li>
                        </ul>

                    </div>
                </div>
            </Block>
        )
    }
}

/* Export */
export default ProPrivacyPolicy
